import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/browser';
import Dialogs from '@/components/dialogs';
import Header from '@/components/Header';
import Login from '@/containers/Login';
import getNavs from '@/navs';
import { getCurrentUser } from '@/models/user/selectors';
import { Spin, Icon, ConfigProvider, Button, message, notification, Layout } from 'antd';
import GlobalSearch from '@/components/GlobalSearch';
import zhCN from 'antd/es/locale/zh_CN';
import styles from './app.module.scss';
import appPages, { iframePages } from './pages';
import watermark from 'watermark-dom';
import Sidebar from '@/layouts/Sidebar';
import AppHeader from '@/layouts/AppHeader';
import QrConnectCallbackFrame from '@/containers/qrConnectCallbackFrame';
import { initVersionCheck } from '@/utils/versionCheck';
import VersionInfo from '@/components/VersionInfo'; 
//const tenantMode = process.env.APP_MODE === 'tenant'
const hasToken = () => localStorage.getItem(`xb_${process.env.APP_MODE}_token`);
const nextToRegister = () => localStorage.hasOwnProperty('next_to_register');
// const openSubscribeQrcode = () => {
//   notification.info({
//     message: `温馨提示`,
//     description: <div><img src={process.env.PUBLIC_URL +'/'+'qrcode_for_gh_8_8.jpg'}></img><br/>
//     <h3 style={{color:"red"}}>为了确保会员功能正常运行，新用户请先关注公众号，再进行登陆！</h3></div>,
//     placement:'topRight',
//     duration: 0,
//     key:'qrcode'
//   });
// }; 
function AuthLayer(props) {
  console.log('props',props)
  // 测试的开始----------------------------------
  // let manager = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1IjoiNWU4MzIxNTRlMGVlNTcyODFiYTA0OWZmIiwiciI6Im1hbmFnZXIiLCJpYXQiOjE2Nzk4NjU0MzksImV4cCI6MTcxMTQwMTQzOX0.Ios161qlvWN6HRZga7k1NBwBFnaKTOXx8stU2Y0TByQ'
  // let staff = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1IjoiNWRjZmVhNWQzM2U5MzU2OTY1MTA4M2RjIiwiaWF0IjoxNjc5ODYyNzg2LCJleHAiOjE3MTEzOTg3ODZ9.u6sUdJUFgBB_MIP-rRFpzEif50HivO5OoPi_05u6JVg'
  // localStorage.setItem(`xb_${process.env.APP_MODE}_token`, manager)
  // Sentry.setUser({ id: '60a9ce436b956f69ac30894f', username: 'boldoo' });
  // 测试的结束----------------------------------
  //localStorage.setItem('next_to_register',1)

  // 正式的开始----------------------------------
  if (!hasToken() || nextToRegister()) {
    return <Login subscribe={true} />;
  }
  //没有关注公众号的 弹出公众号二维码
  const { user } = props;
  const userJs = user.toJS()
  // if (userJs._id && !userJs.subscribe) {
  //   return <Login subscribe={false} />;
  // }
  if (!user || !user.get('_id')) {
    const antIcon = <Icon type="loading" style={{ fontSize: 64 }} spin />;
    return (
      <div className={styles.loading}>
        <Spin indicator={antIcon} />
      </div>
    );
  }
  Sentry.setUser({ id: user.get('_id'), username: user.get('name') });
  // 正式的结束----------------------------------

  /*
  watermark.load({
    watermark_txt: `${process.env.APP_MODE === 'tenant' ? 't' : 'm'}-${user.get(
      '_id'
    )}`,
    watermark_fontsize: 10,
    watermark_alpha: 0.05,
    watermark_height: 30,
    watermark_width: 200
  });
  */
  return props.children;
}

function OopsPage({ errorMessage, eventId }) {
  return (
    <div className={styles.errorWrap}>
      <div className={styles.content}>
        <div className={styles.icon}></div>
        <div className={styles.title}>抱歉，应用出错了</div>
        <div className={styles.subTitle}>
          {errorMessage || '抱歉，服务器出错了。'}
        </div>
        <div className={styles.extra}>
          <a href="/">
            <Button type="default">
              <span>返回首页</span>
            </Button>
          </a>
          {eventId && (
            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={() =>
                Sentry.showReportDialog({
                  title: '看来您在使用我们产品中发生了一些问题',
                  subtitle: '报错内容已通知到我们的技术团队。',
                  subtitle2: '如果您愿意帮忙，您可以在下方告诉我们复现步骤',
                  labelEmail: '您的联系方式',
                  eventId,
                  lang: 'zh-cn',
                })
              }
            >
              问题反馈
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: null,
      eventId: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);

      this.setState({
        eventId,
      });
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <OopsPage
          errorMessage={this.state.errorMessage}
          eventId={this.state.eventId}
        />
      );
    }

    return this.props.children;
  }
}

const appMode = process.env.APP_MODE;

function AppPages() {
  return appPages.map((item) => {
    return <Route key={item.path} {...item} />;
  });
}
function IframePages() {
  return iframePages.map((item) => {
    return <Route key={item.path} {...item} />;
  });
}

function App(props) {
  const [navs, setNavs] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const user = useSelector(getCurrentUser);
  const defaultRouter = navs?.[0]?.to;
  const isIframe = window.location.pathname?.startsWith("/iframe-");

  useEffect(() => {
    setNavs(getNavs(user.toJS()));
  }, [user]);
  
  // 初始化版本检测，每60秒检测一次
  useEffect(() => {
    initVersionCheck(60000);
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
      <Switch>
        {/* 添加不受权限控制的页面路由 */}
        <Route path="/qr_connect_callback_frame" component={QrConnectCallbackFrame} />
        <AuthLayer user={user}>
          <ConfigProvider locale={zhCN}>
            {!isIframe ?
              <Layout style={{ height: '100vh' }}>
                <Layout.Sider
                  className="app-layout-sider"
                  collapsible
                  width={220}
                  onCollapse={(collapsed, type) => {
                    setIsCollapsed(collapsed)
                  }}
                >
                  <Sidebar isCollapsed={isCollapsed} />
                </Layout.Sider>
                <Layout style={{ marginLeft: isCollapsed ? 80 : 220, transition: 'margin 0.2s' }}>
                  <AppHeader />

                  <Layout.Content style={{ padding: 16, overflowX: 'hidden' }}>

                    {/* <Header /> */}
                    <GlobalSearch />
                    <Dialogs />
                    <Switch>
                      {defaultRouter && (
                        <Redirect from="/" exact strict to={defaultRouter} />
                      )}
                      <AppPages />
                      <Route exact render={() => <OopsPage errorMessage="404" />} />
                    </Switch>
                    <VersionInfo />
                  </Layout.Content>
                </Layout>
              </Layout> :
              <Switch>
                <IframePages />
                <Route exact render={() => <OopsPage errorMessage="404" />} />
              </Switch>}
          </ConfigProvider>
        </AuthLayer>
        </Switch>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
